import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import { BackIcon } from '../../icons';

import style from 'components/common/Form/BackButton/BackButton.module.scss';

function BackButton(props) {
    const { text, className, href, history, onClick, light } = props;

    const btnClass = cn(style.button, {
        [className]: className,
    });

    const handleClick = useCallback(
        (ev) => {
            if (href) {
                history.push(href);
            } else {
                history.goBack();
            }

            if (onClick) {
                onClick(ev);
            }
        },
        [href, onClick, history],
    );

    return (
        <button className={btnClass} onClick={handleClick}>
            <BackIcon fill={light && '#FFF'} />
            {text}
        </button>
    );
}

BackButton.propTypes = {
    text: PropTypes.string,
};

BackButton.defaultProps = {
    text: 'Back',
};

export default withRouter(BackButton);
